import React, { Fragment } from "react";
import CourseSectionVideo from "./CourseSectionVideo";

const CourseVideos = ({ section: { sectionname, videos }, course, id }) => {
  return (
    <Fragment>
      <div className="all-content-section">
        <div className="section-container">
          <p className="section-title-alt red">{sectionname}</p>
          {videos &&
            videos.length > 0 &&
            videos.map((video) => {
              return (
                <CourseSectionVideo
                  video={video}
                  key={video._id}
                  course={course}
                  id={id}
                />
              );
            })}
        </div>
      </div>
    </Fragment>
  );
};

export default CourseVideos;
